<div class="value">
    <div class="value-title" id="value">
        {{ value }}
    </div>
</div>
<div class="label">
    <div class="label-title" id="label">
        {{ title | translate }}
    </div>
</div>
